<h2 class="global-title">
    Email templates
</h2>
<div class="top-bar">
    <div class="top-bar-item">
        <p-button label="Add new" routerLink="/management/create-booking-email-template"></p-button>
    </div>
    <div class="top-bar-item">
        <p-selectButton [options]="activeLanguages" [(ngModel)]="selectedLanguage"
            (onChange)="updateSelectedLanguage()"></p-selectButton>
    </div>
</div>

<p-table [value]="activeTemplates">
    <ng-template pTemplate="header">
        <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Language</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template>
        <tr>
            <td>
                {{template.id}}
            </td>
            <td>
                <a routerLink="/management/edit-booking-email-template/{{template.id}}">
                    {{template.name}}
                </a>
            </td>
            <td>
                {{template.language.name}}
            </td>
        </tr>
    </ng-template>
</p-table>